import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import ContentCopy from '@mui/icons-material/ContentCopy';
import AdminLayout from './AdminLayout';
import { Navigate } from 'react-router-dom';
import { fetchWhatsappLink } from './api/whatsapp';
// uses getMeCached for session resolve
import { getMeCached } from './authCache';
import QRCode from 'qrcode';

export default function WhatsappOnboarding() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [copyMsg, setCopyMsg] = useState('');
  const [qrDataUrl, setQrDataUrl] = useState('');
  const normalizeUser = (u) => {
    if (!u) return u;
    const schoolId = u.school_id || u.school || u.school_name;
    return { ...u, school_id: schoolId };
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { ok, data } = await getMeCached();
        if (!cancelled && ok && data && data.admin_user) setUser(normalizeUser(data.admin_user));
      } catch (_) { /* ignore */ }
      finally { if (!cancelled) setChecking(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const run = async () => {
      if (!user) return;
      const schoolId = user.school_id || user.school_name;
      try {
        const info = await fetchWhatsappLink(schoolId);
        setData(info);
        try {
          const url = await QRCode.toDataURL(info.wa_me_url, { width: 200, margin: 1 });
          setQrDataUrl(url);
        } catch {
          // QR oluşturma başarısız olursa sessizce geç
        }
      } catch (e) {
        setError('Veri alınamadı');
      }
    };
    run();
  }, [user]);

  const handleLogout = () => {
    localStorage.removeItem('adminUser');
    window.location.href = '/admin';
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopyMsg('Kopyalandı');
  };

  const handleCloseSnack = () => setCopyMsg('');

  if (checking) return null;
  if (!user) return null;
  if (user && user.role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="WhatsApp Kayıt">
      <Card sx={{ maxWidth: 520, mx: 'auto' }}>
        <CardHeader title="QR ile Kayıt" />
        <CardContent>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {data && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Ön Tanımlı Mesaj"
                value={data.prefilled_text}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <IconButton onClick={() => handleCopy(data.prefilled_text)}>
                      <ContentCopy />
                    </IconButton>
                  )
                }}
                fullWidth
              />
              <TextField
                label="WhatsApp Linki"
                value={data.wa_me_url}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <IconButton onClick={() => handleCopy(data.wa_me_url)}>
                      <ContentCopy />
                    </IconButton>
                  )
                }}
                fullWidth
              />
              <Box sx={{ textAlign: 'center' }}>
                <Box component="img" src={qrDataUrl || data.qr_png_url} alt="QR" sx={{ border: 1, borderColor: 'divider', maxWidth: '100%', width: 220 }} />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <Button variant="outlined" onClick={async () => {
                  try {
                    let href = qrDataUrl;
                    if (!href && data?.qr_png_url) {
                      const res = await fetch(data.qr_png_url);
                      const blob = await res.blob();
                      href = URL.createObjectURL(blob);
                    }
                    if (!href) return;
                    const a = document.createElement('a');
                    a.href = href;
                    a.download = `${data.school_id || data.school_name || 'school'}.png`;
                    a.click();
                    if (href.startsWith('blob:')) URL.revokeObjectURL(href);
                  } catch {
                    // no-op
                  }
                }}>PNG indir</Button>
                <Button variant="outlined" onClick={() => window.print()}>Yazdır</Button>
              </Box>
              <Alert severity="info">
                {`Veli QR’ı taradığında WhatsApp açılır; 'KAYIT' mesajını göndererek kaydını tamamlar.`}
              </Alert>
            </Box>
          )}
        </CardContent>
      </Card>
      <Snackbar open={Boolean(copyMsg)} autoHideDuration={2000} onClose={handleCloseSnack} message={copyMsg} />
    </AdminLayout>
  );
}
